import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const IletisimPage = lazy(() => import('../pages/iletisim/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const ConsultationPage = lazy(() => import('../pages/consultation/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const VideoPodcastPage = lazy(() => import('../pages/video-podcast/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'about',
        element: <AboutPage />,
      },
      {
        path: 'services',
        element: <ServicesPage />,
      },
      {
        path: 'blog',
        element: <BlogPage />,
      },
      {
        path: 'iletisim',
        element: <IletisimPage />,
      },
      {
        path: 'consultation',
        element: <ConsultationPage />,
      },
      {
        path: 'giris',
        element: <LoginPage />,
      },
      {
        path: 'video-podcast',
        element: <VideoPodcastPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
];

export default routes;
